/**
 * 从fieldid中提取数据
 */
interface FieldInfo {
  billno?: string;
  actionType?: string;
  action?: string;
  uiType?: string;
}
export default function getFieldInfo(fieldid: string): FieldInfo {
  const result: FieldInfo = {};
  const billnoMatchs = fieldid.match(/^([a-zA-Z0-9_\-]+)\|/);
  const actionMatchs = fieldid.match(/btn([A-Z][a-zA-Z0-9]+)(_([a-zA-Z0-9]+))?/);
  const actionMatchs2 = fieldid.match(/([A-Z][a-zA-Z0-9]+(-_)?[A-Z][a-zA-Z0-9]+)_(icon|btn|img)/);
  if(billnoMatchs && billnoMatchs.length === 2) {
    result.billno = billnoMatchs[1];
  }
  if(actionMatchs && actionMatchs.length > 1) {
    result.action = actionMatchs[1];
    result.uiType = actionMatchs[3];
  }
  if(!result.action && actionMatchs2 && actionMatchs2.length > 1) {
    result.action = actionMatchs2[1];
  }
  return result;
}
